import { Box } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import IncDataGridColumnMenu from '../inc-data-grid-column-menu/inc-data-grid-column-menu.component';
import IncDataGridToolbar from '../inc-data-grid-toolbar/inc-data-grid-toolbar.component';
import { IncDataGridProps } from '../inc-data-grid.component';
import { generateStyles, isInitialLoad } from '../inc-data-grid.utils';

const IncDataGridWrapee = ({
  'data-testid': dataTestId = 'IncDataGrid',
  resizable,
  onRowClick,
  sx,
  slots,
  slotProps,
  initialState,
  dataGridType = 'primary',
  toolbar,
  BoxProps,
  rows,
  loading,
  ...rest
}: IncDataGridProps & { apiRef?: any; onRowSelectionModelChange?: any }) => {
  return (
    <Box
      display="flex"
      data-testid={dataTestId}
      flexDirection="column"
      pt={2}
      height={isInitialLoad(rows, loading) ? 280 : 'auto'}
      {...BoxProps}
    >
      <DataGridPremium
        onRowClick={(params, event, details) => {
          if (window.getSelection().type === 'Range') {
            event.preventDefault();
            event.stopPropagation();
          } else if (onRowClick) {
            onRowClick(params, event, details);
          }
        }}
        density="standard"
        getRowSpacing={() => ({ bottom: 10 })}
        sx={[
          theme => generateStyles(theme, dataGridType),
          {
            '& .MuiDataGrid-columnSeparator': !resizable && {
              display: 'none',
            },
            '& .MuiDataGrid-virtualScrollerRenderZone': {
              '& .MuiDataGrid-row': {
                cursor: !!onRowClick ? 'pointer' : 'default',
              },
            },
            '.MuiDataGrid-virtualScrollerContent': {
              position: 'relative !important',
            },
            '.MuiDataGrid-cell:focus': {
              outline: !!onRowClick ? 'none' : 'default',
            },
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        slots={{
          columnMenu: IncDataGridColumnMenu,
          toolbar: toolbar ? IncDataGridToolbar : undefined,
          ...slots,
        }}
        slotProps={{
          row: {
            'data-testid': `${dataTestId}.Row`,
          },
          pagination: {
            //@ts-ignore
            'data-testid': `${dataTestId}.Pagination`,
          },
          toolbar: {
            toolbar,
          },
          loadingOverlay: {
            variant: 'linear-progress',
            noRowsVariant: 'skeleton',
          },
          ...slotProps,
        }}
        disableRowSelectionOnClick={true}
        initialState={{
          ...initialState,
        }}
        checkboxSelection={toolbar?.bulkEdit?.enabled}
        pageSizeOptions={[10, 50, 100, 500]}
        rows={rows}
        loading={loading}
        {...rest}
      />
    </Box>
  );
};

export default IncDataGridWrapee;
